import {
	GET_WORK_CENTER,
	GET_WORK_CENTER_ERROR,
	GET_WORK_CENTER_SUCCESS,
} from '../../../constants';

export const getWorkCenterReducer = (state, actions) => {
	switch (actions.type) {
		case GET_WORK_CENTER:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
				workCenters: undefined
			};
		case GET_WORK_CENTER_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
				workCenters: undefined
			};
		case GET_WORK_CENTER_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenters: actions.payload,
			};
		default:
			return state;
	}
};
